// @flow

import React from "react";
import { Link } from "react-router-dom";
import Toolbar from "@material-ui/core/Toolbar";
import { withStyles } from "@material-ui/core/styles";

import UserMenu from "./UserMenu";
import type { CurrentUser } from "containers/Security/types";

const styles = (theme) => ({
  toolbar: {
    backgroundColor: theme.palette.background.paper,
    borderBottom: "1px solid #eee",
  },
  logo: {
    height: "60%",
    position: "absolute",
    transform: "translateY(-50%)",
  },
});

type Props = {
  classes: Object,
  logo: string,
  logoAlt: string,
  to: string,
  logout: Function,
} & CurrentUser;

const TopToolbar = (props: Props) => {
  return (
    <div>
      <Toolbar className={props.classes.toolbar}>
        <Link to={props.to}>
          <img
            className={props.classes.logo}
            src={props.logo}
            alt={props.logoAlt}
          />
        </Link>
        <UserMenu currentUser={props.currentUser} logout={props.logout} />
      </Toolbar>
    </div>
  );
};

export default withStyles(styles)(TopToolbar);
